'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVideoReservation = exports.cancelReservationEntity = exports.createReservation = undefined;

var _sagaTools = require('@classpass/saga-tools');

var createReservation = exports.createReservation = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CREATE_RESERVATION_ENTITY', function (client, userId, body) {
  return client.reservations.create(userId, body);
}); /* eslint-disable import/prefer-default-export */

var cancelReservationEntity = exports.cancelReservationEntity = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CANCEL_RESERVATION_ENTITY', function (client, userId, reservationId, body) {
  return client.reservations.update(userId, reservationId, body);
}, { defaultKey: function defaultKey(client, userId, reservationId) {
    return reservationId;
  } });

var createVideoReservation = exports.createVideoReservation = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CREATE_VIDEO_RESERVATION_ENTITY', function (client, userId, body) {
  return client.reservations.createVideoReservation(userId, body);
}, { defaultKey: function defaultKey(client, userId, body) {
    return body.content_id;
  } });